import { forwardRef, memo } from 'react';
import { FormattedMessage } from 'react-intl';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

export const TableSettingsTooltip = memo(
    forwardRef<HTMLDivElement>((props, ref) => (
        <Tooltip ref={ref} {...props}>
            <FormattedMessage id="intl-msg:vehicle_diagnostics.table_settings.header" />
        </Tooltip>
    )),
);

TableSettingsTooltip.displayName = 'TableSettingsTooltip';
